import ColumnSet from '@/components/grid/columns/column-set';
import ColumnsDefinition from '@/common/definitions/columns/api-logs';

export default function createColumns(expandData) {
    return new ColumnSet({
        id: 'api-logs-list',
        ...ColumnsDefinition(expandData),
    });
}
